import { useEffect, useRef } from "react";
import { getById } from "../../js/db";
import { formatDate } from "../../js/utils/formatters";

function formatStamp(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return `${formatDate(iso)} · ${date.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  })}`;
}

function senderName(userId) {
  const user = getById("users", userId);
  return user?.name || "Someone";
}

export default function MessageThreadView({ messages = [], currentUserId }) {
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ block: "end" });
  }, [messages.length]);

  return (
    <div className="message-list">
      {messages.length ? (
        messages.map((message) => {
          const own = message.sender_id === currentUserId;
          return (
            <article
              key={message.id}
              className={`message-bubble${own ? " is-own" : ""}`}
            >
              <span className="message-meta">
                {senderName(message.sender_id)} · {formatStamp(message.timestamp)}
              </span>
              <p className="message-text">{message.message_text}</p>
              {message.attachments?.length ? (
                <ul className="message-attachments">
                  {message.attachments.map((file) => (
                    <li key={file.id}>{file.file_name || "Attachment"}</li>
                  ))}
                </ul>
              ) : null}
            </article>
          );
        })
      ) : (
        <p className="muted">No notes yet. Begin whenever you are ready.</p>
      )}
      <div ref={endRef} />
    </div>
  );
}
